export class LessonConst {
  public static readonly LESSON_TIME = 50;
}
